import basic from '../asset/imgs/wang/basic.PNG';
import bling from '../asset/imgs/wang/bling.PNG';
import cry  from '../asset/imgs/wang/cry.PNG';
import love from '../asset/imgs/wang/love.PNG';
import start from '../asset/imgs/wang/start.PNG';

export default {
  data : [basic, bling, cry, love, start]
}